module.exports = __webpack_public_path__ + "static/why-1-f5bc2e7cf98e6ef3ccc4b8f7f42418a5.png";